import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Drawer from "../../assets/drawer.png";
import Drawer2 from "../../assets/drawer2.png";
import DrawerNoIcon from "../../assets/drawer-no-icon.png";
import Drawer2NoIcon from "../../assets/drawer2-no-icon.png";
import ServiceDrawer from "../../assets/serviceDrawer.png";
import TabBar from "../../assets/tabBar.png";
import TabBar2 from "../../assets/tabBar2.png";
import TabBar3 from "../../assets/tabbar-ios.png";
import TabBar4 from "../../assets/tabbar-ios-no-title.png";
import TabBar5 from "../../assets/tabbar-ios-services.png";
import TabBar6 from "../../assets/tabbar-ios-services-no-title.png";
import ServiceTabBar from "../../assets/serviceTabBar.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { Alert, Checkbox, CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	alert: {
		cursor: "pointer",
		"& *": {
			cursor: "pointer",
		},
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	},
});

export default function Navigation({
	drawerWidth,
	setRun,
	goToAppearance,
	setGoToAppearance,
}) {
	const classes = useStyles();
	const [navigationType, setNavigationType] = useState("Tab Bar");
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [drawerHovered, setDrawerHovered] = useState(false);
	const [tabBarHovered, setTabBarHovered] = useState(false);
	const navigate = useNavigate();
	const { user } = useContext(UserContext);
	const alert = useAlert();
	const service = user.app.appType === "Services";
	const { t } = useTranslation();

	const [hideMenuTitle, setHideMenuTitle] = useState(null);
	const [hideMenuIcon, setHideMenuIcon] = useState(null);

	useEffect(() => {
		setRun(true);
	}, []);

	useEffect(() => {
		if (goToAppearance) {
			setGoToAppearance(false);
			navigate("/colors");
		}
	}, [goToAppearance]);

	const getNavigationData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setData(res.data);
			setNavigationType(res.data.navigationType);
			setHideMenuTitle(res.data.hideMenuTitle);
			setHideMenuIcon(res.data.hideMenuIcon);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const saveNavigationData = useCallback(async () => {
		setLoading(true);
		if (
			data.creatorPages.filter((page) => page.visible).length > 5 &&
			navigationType === "Tab Bar"
		) {
			alert.show(t("navigation.error"), { type: "error" });
		} else {
			try {
				await axios.post(
					ADMIN_URL + "creators",
					{ navigationType, hideMenuTitle, hideMenuIcon },
					{
						headers: { authorization: localStorage.getItem("token") },
					}
				);
				alert.show(t("general.success"), { type: "success" });
			} catch (error) {
				console.log(error);
			}
		}
		setLoading(false);
	}, [data, hideMenuTitle, navigationType, hideMenuIcon]);

	useEffect(() => {
		getNavigationData();
	}, []);

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("navigation.title")}
						</Typography>
						<div className={classes.cardInfo}>
							<RadioGroup
								aria-labelledby="demo-radio-buttons-group-label"
								defaultValue="Tab Bar"
								name="radio-buttons-group"
								value={navigationType}
								onChange={(e) => {
									setNavigationType(e.target.value);
								}}
							>
								<Grid container className={classes.cardForm}>
									<Grid
										item
										xs={12}
										sm={6}
										container
										direction="column"
										className={classes.cardGrid}
									>
										<FormControlLabel
											value="Tab Bar"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={t("navigation.tabBar")}
										/>
										<div style={{ position: "relative" }}>
											<img
												src={
													service
														? drawerHovered
															? ServiceTabBar
															: ServiceTabBar
														: drawerHovered
														? TabBar2
														: TabBar
												}
												alt="iphone"
												onMouseOver={() => {
													setTabBarHovered(true);
												}}
												onMouseLeave={() => {
													setTabBarHovered(false);
												}}
												className={classes.iphone}
											/>
											<img
												src={
													user.app.appType === "Services"
														? hideMenuTitle
															? TabBar6
															: TabBar5
														: hideMenuTitle
														? TabBar4
														: TabBar3
												}
												alt="tabbar"
												onMouseOver={() => {}}
												onMouseLeave={() => {}}
												className={classes.iphone}
												style={{ position: "absolute", top: 0, left: 0 }}
											/>
										</div>
									</Grid>
									<Grid
										item
										xs={12}
										sm={6}
										container
										direction="column"
										className={classes.cardGrid}
									>
										<FormControlLabel
											value="Drawer"
											control={
												<Radio
													id="drawer"
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={t("navigation.drawer")}
										/>
										<img
											src={
												service
													? drawerHovered
														? ServiceDrawer
														: ServiceDrawer
													: drawerHovered
													? hideMenuIcon
														? DrawerNoIcon
														: Drawer2
													: hideMenuIcon
													? DrawerNoIcon
													: Drawer
											}
											alt="iphone"
											onMouseOver={() => {
												setDrawerHovered(true);
											}}
											onMouseLeave={() => {
												setDrawerHovered(false);
											}}
											className={classes.iphone}
										/>
									</Grid>
								</Grid>
							</RadioGroup>
						</div>
						<div style={{ maxWidth: "400px", margin: "auto" }}>
							<Typography
								sx={{
									fontSize: 12,
									marginTop: 2,
									marginBottom: 0,
									fontWeight: 700,
									textTransform: "uppercase",
								}}
								color="text.secondary"
								gutterBottom
							>
								{t("navigation.options")}
							</Typography>
							{navigationType === "Tab Bar" ? (
								<FormControlLabel
									control={
										<Checkbox
											checked={!hideMenuTitle && !hideMenuTitle}
											onChange={(e) => {
												setHideMenuTitle(!hideMenuTitle);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("navigation.hideMenuTitle")}
								/>
							) : (
								<FormControlLabel
									control={
										<Checkbox
											checked={!hideMenuIcon && !hideMenuIcon}
											onChange={(e) => {
												setHideMenuIcon(!hideMenuIcon);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("navigation.hideMenuIcon")}
								/>
							)}
						</div>
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								id="navigation-save"
								variant="contained"
								size="small"
								onClick={saveNavigationData}
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
